export type RestoreAction = "validate-via-me" | "mark-unauthenticated";

/**
 * Decide what session restoration should do on app load.
 *
 * The readable `csrfToken` cookie is the source of truth for "a session may
 * exist": it is set at login and cleared at logout, alongside the httpOnly
 * `token` cookie. Unlike the persisted `isAuthenticated` flag, it is NOT
 * subject to the zustand-persist hydration race that logged users out on the
 * SSR `/xdao` entry — so the decision depends ONLY on the cookie.
 */
export function decideRestoreAction(params: { hasCsrfToken: boolean }): RestoreAction {
  return params.hasCsrfToken ? "validate-via-me" : "mark-unauthenticated";
}
